function refreshCart(cond = true, trigger = true) {
	async function handleSuccess(cart){
			let updateCartUi = false;
			let cartCount = 0
			let cartItems = cart.items
			let cartAttr = cart.attributes
			const hg_gwp = $("#hg_gwp_enable")[0]?.value == 'true'
			const hg_gwp_bonus = $("#hg_gwp_bonus")[0]?.value
			const hg_gwp_collection = $("#hg_gwp_collection")[0]?.value
			// console.log("123", hg_gwp, hg_gwp_bonus, hg_gwp_collection);
			let hg_gwp_bonus_count = 0
			const hg_gwp_eligible_products = []
			for(let k in cartAttr){
				if(k.includes('groupbundle')){
					let theAttr = cartAttr[k]
					theAttr = theAttr.split('|')
					cartCount += parseInt(theAttr[6])
				}
			}
			const xmas25Gwp = XMAS25_GWP;

			// invalid bundle deletion
			const groupBundle = new Map();

			if(cart.attributes){
				const keyMapping = [
						"title",
						"handle",
						"image",
						"compare_price",
						"price",
						"qty_items",
						"new_bundle_qty", // Using a snake_case version of the variable
						"qty_max",
						// Index 8: ${existBundle.discMsg}
						"disc_msg"
				];

				for (const key in cart.attributes) {
					if (key.includes('groupbundle:') && cart.attributes.hasOwnProperty(key)) {
						const groupBundleId = key.split(':').pop() + ""
						const parts = cart.attributes[key].split('|');
						const bundleData = {};

						parts.forEach((value, index) => {
								// Assign the value to the corresponding key from keyMapping
								bundleData[keyMapping[index]] = value;
						});

						// Use the original bundle key for the new map
						groupBundle.set(groupBundleId, bundleData)
					}
				}

				console.log(groupBundle);
			}

			const bundleToDelete = []
			
			cartItems.map((item) => {
				if(!item.properties._groupbundle){
					cartCount += item.quantity
				}

				if(item.properties._groupbundle){
					const currentQty = item.quantity

					const activeBundle = groupBundle.get(item.properties._groupbundle)
					if(activeBundle) {
						const correctQty = activeBundle.qty_items * activeBundle.new_bundle_qty;
						if((activeBundle.qty_items+"").includes(',')){}
						else if(currentQty!=correctQty) {
							bundleToDelete.push(item.id)
						}
					}

					// if(DISABLED_BUNDLES.includes(item.handle)){
					// 	bundleToDelete.push(item.id)
					// }
				}

				console.log(item.handle, item.id);
				if(!!hg_gwp_bonus && hg_gwp_collection.includes(item.id)){
					hg_gwp_eligible_products.push(item.id);
				}

				if(!!hg_gwp_bonus && hg_gwp_bonus == item.id+"" && !!item.properties._gwp_hg){
					hg_gwp_bonus_count += 1;
				}

			})

			console.log("bundleToDelete", bundleToDelete)
			if(bundleToDelete.length){
				let updates = {}
				bundleToDelete.forEach(function(varId){
					updates[varId] = 0;
				})
				await $.ajax ({
					type: 'POST',
					url: '/cart/update.js',
					data: {
						updates: updates,
					},
					dataType: 'json',
				})
				updateCartUi = true;
			}

			// console.log(123, "", hg_gwp_eligible_products)
			// console.log(123, !!hg_gwp , hg_gwp_bonus_count != 0 , hg_gwp_eligible_products.length == 0)

			if(!!hg_gwp && hg_gwp_bonus_count == 0 && hg_gwp_eligible_products.length != 0){
				// console.log(123, "Should add product")
				try{
					await $.ajax({
						type: 'POST',
						url: '/cart/add.js',
						data: {
							id: hg_gwp_bonus,
							quantity: 1,
							properties: {
								"_gwp_hg": 1
							}
						},
						dataType: 'json',
					})
					updateCartUi = true;
				}
				catch(error){
					// console.log(error);
					let e = JSON.parse(error.responseText);
					$("#global-loading").removeClass("active");
					let desc = e.description;
					$("#global-notification-msg").html(desc);
					$(".global-notification").addClass("active");
					setTimeout(function () {
						$(".global-notification").removeClass("active");
					}, 4500);
				}
			} else if (!!hg_gwp && hg_gwp_bonus_count != 0 && hg_gwp_eligible_products.length == 0){
				// console.log(123, "Should remove product")
				try {
					await $.ajax({
						type: 'POST',
						url: '/cart/change.js',
						data: { 
								id: hg_gwp_bonus,
								quantity:0,
						},
						dataType: 'json',
					})
					updateCartUi = true;
				}
				catch(error){
					console.log(error);
					let e = JSON.parse(error.responseText);
					$("#global-loading").removeClass("active");
					let desc = e.description;
					$("#global-notification-msg").html(desc);
					$(".global-notification").addClass("active");
					setTimeout(function () {
						$(".global-notification").removeClass("active");
					}, 4500);
				}
			} else {
				// console.log(123, "Do nothing")
				updateCartUi = true;
			}

			async function xmas25GwpUpdate(tier = ''){
				// delete gwp products if it doesn't match the condition
				if(tier == 0) tier = '';
				await $.ajax ({
					type: 'POST',
					url: '/cart/update.js',
					data: {
							attributes:{
								'_xmas25_gwp': tier+""
							}
						},
					dataType: 'json',
				})
				updateCartUi = true;
			}

			async function checkXmas25Gwp(){
				if(!xmas25Gwp?.enabled) {
					// check if reward product in cart is invalid
					xmas25GwpUpdate();
					return;
				}

				// tier to choose
				const tierCurrent = cart.attributes['_xmas25_gwp'] || 0;
				let tierToApply = 0;
				xmas25Gwp.tiers.forEach((tier,idx)=> {
					if(cart.original_total_price >= tier){
						tierToApply = idx+1;
					}
				})

				console.log("tierToApply", tierToApply)

				if(tierCurrent != tierToApply){
					await xmas25GwpUpdate(tierToApply);
				}
			}

			await checkXmas25Gwp();

			if(updateCartUi){
				if (cond) {
					const cartHtml = await $.get('/cart?view=json');
					$("#header-cart").html(cartHtml);
					if (trigger) {
						$("body").toggleClass("active");
					}

					//-- check max purchase
					if($('.header-cart').find('.purchase-limit-notif').length > 0) {
						$('#header-cart-checkout').addClass('disabled');
					} else {
						$('#header-cart-checkout').removeClass('disabled');
					}

					// Check giftbox
					$('.header-cart .giftbox-items').each(function() {
						$(this).find('.each').each(function() {
							const varId = $(this).data('variant-id');
							const gbiQty = parseInt($(this).data('qty'));
							let qtyBalance = gbiQty;

							$(`.header-cart__item[data-variant-id="${varId}"]`).each(function() {
								if(qtyBalance > 0) {
									let qty = $(this).find('.global-qty-text').val();
									if($(this).find('.fake-qty').length) {
										qty = parseInt($(this).find('.fake-qty').text());
									}
									const qtyText = qty - qtyBalance < 0 ? 0 : qty - qtyBalance;
									qtyBalance = qtyBalance - qty;
									if(qtyText <= 0) {
										$(this).addClass('hide-mobile');
									} 
									$(this).find('.global-qty-text').addClass('hide-mobile');
									if($(this).find('.fake-qty').length) {
										$(this).find('.fake-qty').remove();
									}
									$(`<span class="fake-qty body-4">${qtyText}</span>`).insertAfter($(this).find('.global-plus'));
								}
							});
						});
					});
					// End check giftbox

					lazyLoadInstance.update();
				}
				else {
					const cartHtml = await $.get('/cart?view=json');
					$("#header-cart").html(cartHtml);
				}
			}

			$(".cart_count").html(cartCount);
			$("#global-loading").removeClass("active");
		
	}
	$.ajax({
		url: '/cart.js',
		type: 'GET',
		dataType: 'json',
	}).done(function(data){
		handleSuccess(data)
	});
}


function refreshCartPage() {
	// $.ajax({
	// 	url: '/cart.js',
	// 	type: 'GET',
	// 	dataType: 'json',
	// 	success: function (cart) {
	// 		$(".cart_count").html(cart.item_count);
	// 		$.get('/cart?view=jsonpage', function (cart, textStatus) {
	// 			$("#cart-content").html(cart);
	// 			$("#global-loading").removeClass("active");
	// 		});
	// 	}
	// });

	window.location.href = '/cart';
}